import React from "react";
import { Typography, Box } from "@mui/material";

const EmptyState = ({message}) => {
  return (
    <Box style={styles.container}>
      <img
        src={require("../../img/no-cases.svg").default}
        alt="no-cases"
        style={styles.image}
      />
      <Typography style={styles.description}>
        {message}
      </Typography>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "100px",
    height: "100px",
    marginTop: "48px",
  },
  description: {
    textAlign: "center",
    color: "#757575",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    width: "75vw",
    marginTop: "16px",
  },
};

export default EmptyState;
